import React from "react"
import Link from "next/link"

// public list view
export const LogosWithLinks: React.FC = () => {
  return (
    <div>
      {/* <div>Made with </div> */}
      <Link href="https://sens.center/" target="_blank" rel="noopener noreferrer" className="flex">
        <div>
          <img className="inline-block w-4 align-middle stroke-current" src="/img/sens_center_gr.svg" alt="" />
        </div>
        <div>
          <img
            className="inline-block w-20 stroke-current align-middle ml-1"
            src="/img/sens_center_black3.svg"
            alt="logo_full"
          />
        </div>
      </Link>
    </div>
  )
}
